import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OPEN_EVENT, readConsent, saveConsent } from "@/lib/consent";
import { ADS_ON } from "@/lib/legal";
import { useLang } from "@/lib/i18n";

const BTN = "flex h-10 flex-1 items-center justify-center rounded-full px-5 text-xs font-semibold uppercase tracking-[0.16em] transition-colors duration-300 md:h-11";

export function CookieConsent() {
  const [open, setOpen] = useState(() => !readConsent());
  const { t } = useLang();

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_EVENT, show);
    return () => window.removeEventListener(OPEN_EVENT, show);
  }, []);

  if (!open) return null;
  const choose = (analytics) => { saveConsent(analytics); setOpen(false); };

  return (
    <div role="dialog" aria-label={t("Gestion des cookies")} data-testid="cookie-banner"
      className="fixed inset-x-2 bottom-2 z-[90] rounded-sm border border-[var(--gold)]/50 bg-[var(--ink-2)] p-4 shadow-2xl sm:left-6 sm:right-auto sm:max-w-md md:bottom-6 md:p-5">
      <p className="eyebrow mb-2 hidden md:block">Cookies</p>
      <p className="text-xs leading-relaxed text-[var(--parchment)]/90 md:text-sm">
        {t("Nous utilisons des traceurs nécessaires au panier et au paiement. Avec votre accord, nous mesurons aussi l'audience du site pour l'améliorer")}{t(ADS_ON ? " et l'efficacité de nos publicités (Meta, Google)." : ". Aucun cookie publicitaire.")}{" "}
        <Link to="/cookies" data-testid="cookie-banner-policy-link" className="text-[var(--gold-soft)] underline underline-offset-4">{t("En savoir plus")}</Link>
      </p>
      <div className="mt-3 flex gap-2 md:mt-4">
        <button type="button" data-testid="cookie-refuse-button" onClick={() => choose(false)} className={`${BTN} border border-[var(--line)] text-[var(--parchment)] hover:border-[var(--gold)]`}>{t("Refuser")}</button>
        <button type="button" data-testid="cookie-accept-button" onClick={() => choose(true)} className={`${BTN} bg-[var(--gold)] text-[var(--ink)] hover:bg-[var(--gold-soft)]`}>{t("Accepter")}</button>
      </div>
    </div>
  );
}
